export default __webpack_public_path__ + "static/media/GRANDI_LASTRE_VERTICALI_3.ec79b4cd.jpg";